export default __webpack_public_path__ + "static/media/watches1.d42bde44.jfif";